import { render } from "./IconTrace.vue?vue&type=template&id=2dfc2ae5"
import script from "./IconTrace.vue?vue&type=script&lang=ts"
export * from "./IconTrace.vue?vue&type=script&lang=ts"
script.render = render

export default script